declare let process: { env: { [key: string]: string } };

export const environment = {
  isLocal: process.env.IS_LOCAL === 'true',
  isProd: process.env.NODE_ENV === 'production',
  isQzila: process.env.FRONTEND_URI === 'https://app.qzila.com',
  apiUri: process.env.API_URI,
  uploadsDomain: process.env.UPLOADS_DOMAIN,
  supportEmailAddress: process.env.SUPPORT_EMAIL_ADDRESS,
  frontendUri: process.env.FRONTEND_URI
};
